import React, { createContext, useContext, useState } from "react";
import { getTechnology } from '../services/helper';

interface AppContextType {
  techType: string;
  setTechType: (tech: string) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [techType, setTechType] = useState<string>(getTechnology());

  return (
    <AppContext.Provider value={{ techType, setTechType }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used inside an AppProvider");
  }
  return context;
};
